import { FormEvent } from "react"
import { Head, useForm, usePage } from "@inertiajs/react"
import { AppShell } from "@/components/AppShell"
import { PageHeader } from "@/components/PageHeader"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { ProfileSubNav } from "./ProfileSubNav"

import type { PageProps } from "@/types/inertia"

export default function ProfileDetails() {
  const { props } = usePage<PageProps>()
  const user = props.current_user
  const errors = props.errors ?? {}

  const form = useForm({ name: user?.name ?? "", email: user?.email ?? "" })

  const submit = (e: FormEvent) => {
    e.preventDefault()
    form.patch("/profile", { preserveScroll: true })
  }

  return (
    <>
      <Head title="My details">
        <meta name="description" content="Update your name and the email address you use to log in." />
        <meta property="og:title" content="My details" />
        <meta property="og:description" content="Update your name and the email address you use to log in." />
      </Head>
      <AppShell>
        <PageHeader
          title="Profile"
          description="Manage your account."
          tabs={<ProfileSubNav active="details" />}
        />

        <section className="mt-10 max-w-md">
          <form onSubmit={submit} className="space-y-4">
            <div className="space-y-2">
              <label htmlFor="name">Name</label>
              <Input
                id="name"
                type="text"
                autoComplete="name"
                required
                aria-invalid={!!errors.name}
                value={form.data.name}
                onChange={(e) => form.setData("name", e.target.value)}
              />
              {errors.name && (
                <p className="text-xs text-danger-display">{errors.name}</p>
              )}
            </div>
            <div className="space-y-2">
              <label htmlFor="email">Email</label>
              <Input
                id="email"
                type="email"
                autoComplete="email"
                required
                aria-invalid={!!errors.email}
                value={form.data.email}
                onChange={(e) => form.setData("email", e.target.value)}
              />
              {errors.email && (
                <p className="text-xs text-danger-display">{errors.email}</p>
              )}
            </div>
            <Button type="submit" disabled={form.processing}>
              Save changes
            </Button>
          </form>
        </section>
      </AppShell>
    </>
  )
}
